var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 24,
    viewBox: "0 0 62 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2243 19.8071V16.9724C60.2243 16.0349 59.0148 13.7591 58.3932 13.0016C52.7684 6.15745 41.691 11.618 43.6622 20.1858H20.0159C21.5868 13.4965 14.9704 7.9939 8.55 10.5878C5.23928 11.9243 2.91164 15.7487 3.57716 19.3038C2.60084 19.228 1.55695 18.8728 0.925208 18.1036C-0.836568 15.9541 0.058678 9.06614 2.39983 7.4805C3.70554 6.5951 6.22912 6.35945 7.71387 5.71981C8.37264 5.43533 9.13613 4.66103 9.78645 4.25705C16.1799 0.298007 24.08 -0.3652 31.4582 0.153246C33.1929 0.274441 35.6979 0.4495 37.2519 1.1834C39.9292 2.44754 42.642 4.74014 45.3058 6.13557C49.6046 6.84423 54.4204 6.88799 58.5807 8.27837C62.3509 9.53745 62.1364 13.6194 61.8712 16.9775C61.785 18.0733 61.2834 19.3206 60.2226 19.8087L60.2243 19.8071ZM19.9534 8.08984H27.7302L26.1948 2.43744C22.8672 2.43575 19.548 2.91043 16.3505 3.80593C16.2609 3.90188 16.7609 4.49439 16.8589 4.62063C17.5109 5.4589 18.6021 6.87453 19.3183 7.58823C19.4568 7.72457 19.7896 8.05449 19.9534 8.08984ZM42.3954 7.45693C42.4579 7.36604 41.6184 6.85264 41.5001 6.7769C39.9461 5.78714 35.9783 3.11579 34.3652 2.9239L28.9937 2.54517L30.5899 8.07301L41.6048 7.9939L42.3954 7.45693Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3446 12.4074C59.0319 11.5624 60.1045 23.1382 52.8142 23.9512C44.8532 24.84 43.8245 13.2338 51.3446 12.4074Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1381 12.409C18.947 11.5085 19.9706 23.187 12.6043 23.9495C4.71427 24.7676 3.73963 13.2625 11.1381 12.409Z",
    fill: "#295860"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.ae35ea5da72062d812db88a1c825364b.svg";
export { ForwardRef as ReactComponent };